module.exports = require('./helpers/bundle-url').getBundleURL('5GWKk') + "loansense-logo.51fb517d.png";